import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { LazyAlertIssueSyncCreate } from './async.tsx';

export const AlertIssueSyncCreate = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAlertIssueSyncCreate}
		pageId="async-jira-eoc-alert-issue-syncing"
		shouldShowSpinner
	/>
);
